/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable no-case-declarations */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef, useCallback, useMemo, memo } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import cn from 'classnames';
import moment from 'moment';
import isEqual from 'lodash.isequal';
import PieChart from '../../pictures/pie-chart.svg';
import BarChart from '../../pictures/bar-chart-12.svg';
import LineChart from '../../pictures/line-chart-up-01.svg';
import Time from '../../pictures/hourglass-01.svg';
import Echarts from '../../components/Echarts/Echarts';
import ActionIcon from '../../components/ActionIcon';
import PopUpMenu from '../../components/PopUpMenu';

import Select from '../../components/Select/Select';
import RangePicker from '../../components/DateRangePicker/DateRanglePicker';

import EditIcon from '../../pictures/edit.svg';
import DeleteIcon from '../../pictures/trash.svg';
import RefreshIcon from '../../pictures/refresh-cw-05.svg';

import * as styles from './ConnectedChart.module.scss';

const POINTS_LIMIT = 744;

const tooltipFormatter = (params) => {
  let result = `${params?.[0]?.name}<br/>`;
  let totalValue = 0;
  params.reverse().forEach(item => {
    const { color, seriesName, value, dataIndex } = item;
    totalValue += value;
    result += `<div id="${seriesName}:${dataIndex}" style="display: flex; justify-content: space-between; gap: 20px; align-items: center;">
    <div>
        <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${color};margin-right:4px;"></span>
        <span>${seriesName}</span>
    </div>
    <span style="font-weight: 600">${value}</span>
    </div>`;
  });
  result += '<hr style="border: none; border-top: 1px solid #475467; margin: 8px 0;"/>';
  result += `<div style="display: flex; justify-content: space-between; align-items: center;">
    <div>
    <span>All</span>
    </div>
    <span style="font-weight: 600">${totalValue}</span>
  </div>`;
  return result;
};

const emphasisFormatter = (param) => `${param.value}`;

export const calculateNumberOfPoints = (range) => {
  let startTime; let endTime;

  if (range.includes(':')) {
    // Parse unixtime:unixtime format
    const [start, end] = range.split(':').map(time => parseInt(time, 10));
    startTime = moment.unix(start);
    endTime = moment.unix(end);
  } else {
    // Parse predefined ranges
    endTime = moment();
    switch (range) {
      case '1d':
        startTime = endTime.clone().subtract(1, 'days');
        break;
      case '1w':
        startTime = endTime.clone().subtract(1, 'weeks');
        break;
      case '2w':
        startTime = endTime.clone().subtract(2, 'weeks');
        break;
      case '1M':
        startTime = endTime.clone().subtract(1, 'months');
        break;
      default:
        startTime = endTime;
    }
  }

  // Calculate the number of points
  const durationInMinutes = endTime.diff(startTime, 'minutes');
  const durationInHours = endTime.diff(startTime, 'hours');
  return { durationInMinutes, durationInHours };
};

const findDifferences = (obj1, obj2) => {
  const changes = {};

  const compare = (obj1, obj2, path = '') => {
    for (const key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        const fullPath = path ? `${path}.${key}` : key;
        if (!isEqual(obj1[key], obj2[key])) {
          if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
            compare(obj1[key], obj2[key], fullPath);
          } else {
            changes[fullPath] = { prev: obj1[key], next: obj2[key] };
          }
        }
      }
    }
  };

  compare(obj1, obj2);
  return changes;
};

const MemoizedEcharts = memo(Echarts, (prevProps, nextProps) => 
  // const differences = findDifferences(prevProps.option, nextProps.option);
  // if (Object.keys(differences).length > 0) {
  //   console.log('Differences:', differences);
  // }
   isEqual(prevProps.option, nextProps.option)
);

const mainColors = {
  "2XX": "#7DA0FA",
  "3XX": "#7978E9",
  "4XX": "#fad77d",
  "5XX": "#F3797E",
};

const refreshRates = [
  { value: '30s', title: '30s', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '1m', title: '1m', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '3m', title: '3m', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '5m', title: '5m', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '10m', title: '10m', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '15m', title: '15m', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '30m', title: '30m', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
  { value: '1h', title: '1h', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><RefreshIcon /></div> },
];

const items = [
  {
    key: 'edit',
    title: 'Edit',
    icon: EditIcon,
  },
  {
    key: 'delete',
    title: 'Delete',
    icon: DeleteIcon,
  },
];

const ranges = {
  '1 Day': [moment().startOf('day'), moment().endOf('day')],
  '1 Week': [moment().subtract(1, 'week').add(1, 'day').startOf('day'), moment().endOf('day')],
  '2 Weeks': [moment().subtract(2, 'weeks').add(1, 'day').startOf('day'), moment().endOf('day')],
  '1 Month': [moment().subtract(1, 'month').add(1, 'day').startOf('day'), moment().endOf('day')]
}

function getRandomData(length) {
  return Array.from({ length }, () => (Math.random() > 0.2 ? Math.floor(Math.random() * 200) : 0));
}

export function generateXAxisData(rangeType, toLabel) {
  const now = new Date();
  const xAxisData = [];
  const xAxisTimestamp = [];
  let label = 'Month';
  let labelShort = '1M';

  const generatePerMinute = (startDate, endDate, diffMinutes) => {
    startDate.setSeconds(0, 0);
    endDate.setSeconds(59, 999);
    for (let i = 0; i <= diffMinutes; i++) {
      const date = new Date(startDate);
      date.setMinutes(startDate.getMinutes() + i);
      const unixTime = moment(date).unix();
      xAxisData.push(date.toLocaleString(undefined, { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }));
      xAxisTimestamp.push(unixTime);
    }
    label = 'Minute';
    labelShort = '1m';
  };

  const generatePerHour = (startDate, endDate, diffHours) => {
    startDate.setMinutes(0, 0, 0);
    endDate.setMinutes(59, 59, 999);
    for (let i = 0; i <= diffHours - 1; i++) {
      const date = new Date(startDate);
      date.setHours(startDate.getHours() + i);
      const unixTime = moment(date).unix();
      xAxisData.push(date.toLocaleString(undefined, { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }));
      xAxisTimestamp.push(unixTime);
    }
    label = 'Hour';
    labelShort = '1h';
  };

  const generatePerDay = (startDate, endDate, diffDays) => {
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    for (let i = 0; i <= diffDays - 1; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      const unixTime = moment(date).unix();
      xAxisData.push(date.toLocaleString(undefined, { year: '2-digit', month: '2-digit', day: '2-digit' }).split(',')[0]);
      xAxisTimestamp.push(unixTime);
    }
    label = 'Day';
    labelShort = '1d';
  };

  const generatePerMonth = (startDate, endDate, startYear, startMonth, endYear, endMonth) => {
    startDate = new Date(startYear, startMonth, 1);
    endDate = new Date(endYear, endMonth + 1, 0, 23, 59, 59, 999);
    let currentYear = startYear;
    let currentMonth = startMonth;
    while (currentYear < endYear || (currentYear === endYear && currentMonth <= endMonth)) {
      const date = new Date(currentYear, currentMonth, 1);
      const unixTime = moment(date).unix();
      xAxisData.push(date.toLocaleString(undefined, { year: '2-digit', month: '2-digit' }).slice(0, 7)); // YYYY-MM format
      xAxisTimestamp.push(unixTime);
      currentMonth++;
      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }
    }
    label = 'Month';
    labelShort = '1M';
  };

  const [startUnix, endUnix] = rangeType.split(':').map(Number);
  const startDate = new Date(startUnix * 1000);
  const endDate = new Date(endUnix * 1000);

  const startYear = startDate.getFullYear();
  const startMonth = startDate.getMonth();
  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth();

  const diffHours = Math.ceil((endDate - startDate) / (1000 * 60 * 60));
  const diffDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
  const diffMinutes = Math.ceil((endDate - startDate) / (1000 * 60));

  switch (toLabel) {
    case '1m':
      generatePerMinute(startDate, endDate, diffMinutes);
      break;
    case '1h':
      generatePerHour(startDate, endDate, diffHours);
      break;
    case '1d':
      generatePerDay(startDate, endDate, diffDays);
      break;
    case '1M':
      generatePerMonth(startDate, endDate, startYear, startMonth, endYear, endMonth);
      break;
    default:
      if (diffMinutes <= 60) {
        generatePerMinute(startDate, endDate, diffMinutes);
      } else if (diffHours <= 24) {
        generatePerHour(startDate, endDate, diffHours);
      } else if (diffDays >= 90) {
        generatePerMonth(startDate, endDate, startYear, startMonth, endYear, endMonth);
      } else {
        generatePerDay(startDate, endDate, diffDays);
      }
      break;
  }

  return { data: xAxisData, timeData: xAxisTimestamp, label, labelShort };
}

const types = {
  bar: 'bar',
  line: 'line',
  pie: 'pie'
}

function transformData(seriesArray, type) {
  if (type === 'pie') {

    const aggregatedData = seriesArray.map(series => ({
      value: series?.data.reduce((acc, item) => acc + item, 0),
      name: series.name,
      itemStyle: series.itemStyle
    }))

    return {
      type: types[type] || types.bar,
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 10,
        borderColor: '#fff',
        borderWidth: 2
      },
      label: {
        show: false,
        position: 'center'
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 20,
          fontWeight: 'bold',
          formatter: emphasisFormatter
        }
      },
      labelLine: {
        show: false
      },
      data: aggregatedData
    };
  }

  return seriesArray.map(series => ({
    ...series,
    type: types[type] || types.bar,
    areaStyle: types[type] === 'line' ? {} : undefined,
    smooth: false,
    connectNulls: types[type] === 'line',
    data: series?.data?.map(item => ({
      value: item,
      itemStyle: {
        borderRadius: [0, 0, 0, 0]
      }
    }))
  }));
}

const groupSeries = (xAxisGroup, draftData) => {
  const groups = ["5XX", "4XX", "3XX", "2XX"];
  const colors = mainColors;

  const result = groups.map(group => ({
    data: new Array(xAxisGroup.length).fill(0),
    stack: "a",
    name: group,
    itemStyle: { color: colors[group] },
    emphasis: { focus: "series" }
  }));

  const intervalWidth = (xAxisGroup[1] - xAxisGroup[0]) * 1000;

  draftData.forEach(({ interval, value, group }) => {
    const index = xAxisGroup.findIndex((time, i) => {
      const nextTime = (i < xAxisGroup.length - 1) ? xAxisGroup[i + 1] * 1000 : (time * 1000 + intervalWidth);
      return interval >= time * 1000 && interval < nextTime;
    });

    if (index !== -1) {
      const groupIndex = groups.indexOf(group);
      if (groupIndex !== -1) {
        result[groupIndex].data[index] += value;
      }
    }
  });

  return result;
};

const getTestSeries = (length, groups) => {
  const allSeries = [
    {
      name: '5XX',
      itemStyle: {
        color: mainColors['5XX']
      },
    },
    {
      name: '4XX',
      itemStyle: {
        color: mainColors['4XX']
      },
    },
    {
      name: '3XX',
      itemStyle: {
        color: mainColors['3XX']
      },
    },
    {
      name: '2XX',
      itemStyle: {
        color: mainColors['2XX']
      },
    },
  ];

  return allSeries
    .filter(series => groups.includes(series.name))
    .map(series => ({
      data: getRandomData(length),
      stack: 'a',
      name: series.name,
      itemStyle: series.itemStyle,
      emphasis: {
        focus: 'series'
      },
    }));
};

function ConnectedChart({
  groups,
  initValue,
  refresh,
  chartType,
  interval,
  index,
  id,
  model,
  isCube,
  title,
  description,
  onClickRefetch,
  handleClickOptions,
  handleClickSelectOption,
  moveItems,
  triggerSave,
  triggerSaveRange,
  scrollRef,
}) {
  const ref = useRef(null);
  const allowDragRef = useRef(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const [activeDate, setActiveDate] = useState('');
  const [xAxisData, setXAxisData] = useState([]);

  const handleUpdateSelect = (key, value) => {
    handleClickSelectOption(key, value);
  };

  const [, drop] = useDrop({
    accept: 'dashboard',
    hover(item, monitor) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;

      const dragRect = monitor.getClientOffset();
      const hoverRect = ref.current.getBoundingClientRect();

      const hoverCenterX = hoverRect.left + hoverRect.width / 2;
      const hoverCenterY = hoverRect.top + hoverRect.height / 2;

      const distanceX = dragRect.x - hoverCenterX;
      const distanceY = dragRect.y - hoverCenterY;

      const isOver = Math.abs(distanceX) < hoverRect.width / 2 && Math.abs(distanceY) < hoverRect.height / 2;

      if (isOver && dragIndex !== hoverIndex) {
        moveItems(dragIndex, hoverIndex);
        // eslint-disable-next-line no-param-reassign
        item.index = hoverIndex;
      }
    },
    drop() {
      if (triggerSave) triggerSave();
    }
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'dashboard',
    item: () => ({ id, index }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: () => allowDragRef.current && !!handleClickOptions,
  });
  const opacity = isDragging ? 0 : 1;

  const handleOptionClick = (option) => {
    setDropdownVisible(false);
    if (option === 'edit') {
      handleClickOptions('edit', model);
    } else if (option === 'delete') {
      handleClickOptions('delete', model);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentRange = activeDate?.length ? activeDate : initValue;

  useEffect(() => {
    if (['1d', '1w', '2w', '1M'].includes(currentRange)) {
      setActiveDate(currentRange);
      setXAxisData(generateXAxisData(currentRange, interval));
    } else if (/^\d{10}:\d{10}$/.test(currentRange)) {
      setActiveDate(currentRange);
      setXAxisData(generateXAxisData(currentRange, interval));
    } else {
      setXAxisData(generateXAxisData('2w', interval));
    }
  }, [currentRange, interval]);

  const timeData = useCallback(() => {
    if (model?.data && xAxisData?.timeData) {
      return transformData(groupSeries(xAxisData?.timeData, model.data), chartType);
    }
    return [];
  }, [model, xAxisData, groups, chartType]);

  const resultObject = useMemo(() => timeData(), [timeData]);

  const totalSum = useMemo(() => {
    if (resultObject && resultObject.data) {
      return resultObject.data?.reduce((sum, series) => sum + series.value, 0);
    }
    return 0;
  }, [resultObject]);

  const isEmptySeries = resultObject.length === 0;

  const customOption = useMemo(() => ({
    animation: true,
    title: chartType !== 'pie' ? undefined : {
      text: isEmptySeries ? 'No Data Available' : `{a|Total}\n{b|${totalSum}}`,
      left: 'center',
      top: 'center',
      textStyle: {
        rich: {
          a: {
            fontSize: 14,
            fontWeight: '400',
            color: 'rgba(147, 147, 159, 1)',
            lineHeight: 18
          },
          b: {
            fontSize: 22,
            fontWeight: '600',
            color: 'rgba(8, 8, 40, 1)',
            lineHeight: 30
          },
        }
      }
    },
    grid: {
      top: 50,
      bottom: 40,
      left: 30,
      right: 20,
      containLabel: true
    },
    xAxis: chartType !== 'pie' ? {
      type: 'category',
      data: xAxisData?.data || [],
      name: xAxisData?.label || '',
      nameLocation: 'middle',
      nameTextStyle: {
        fontWeight: '500',
        fontSize: 12,
        padding: 24
      }
    } : undefined,
    yAxis: chartType !== 'pie' ? {
      type: 'value',
      axisLabel: {
        formatter: '{value}'
      },
      name: 'Requests',
      nameLocation: 'middle',
      nameTextStyle: {
        fontSize: 12,
        fontWeight: '500',
        padding: 24
      }
    } : undefined,
    series: isEmptySeries ? [] : resultObject,
    legend: chartType === 'pie' ? {
      center: 'right',
      tooltip: {
        show: false
      }
    } : {
      data: groups,
      icon: 'circle',
      center: 'right',
    },
    labelLine: {
      show: false
    },
    tooltip: chartType === 'pie' ? {
      trigger: 'item',
    } : {
      trigger: 'axis',
      formatter: tooltipFormatter,
      axisPointer: {
        type: chartType === 'bar' ? 'shadow' : 'line',
        label: {
          backgroundColor: '#6a7985'
        },
      }
    },
  }), [chartType, xAxisData, resultObject, totalSum, groups, isEmptySeries]);

  const activateDate = (value) => {
    setActiveDate(value);
  }

  const toggleDropdown = () => {
    setDropdownVisible((status) => !status);
  }

  const handleClickRefetch = () => {
    if (onClickRefetch) {
      onClickRefetch();
    }
  }

  const handleKeyUp = () => {
    allowDragRef.current = false;
  };

  const handleSubmitSend = (input, startDate, endDate) => {
    if (triggerSaveRange) {
      triggerSaveRange(id, input, startDate, endDate);
    }
  }

  useEffect(() => () => {
      window.removeEventListener('dragend', handleKeyUp);
    }, []);
  const { durationInMinutes, durationInHours } = useMemo(() => calculateNumberOfPoints(currentRange), [currentRange]);
  const disable1m  = durationInMinutes > POINTS_LIMIT;
  const disable1h  = durationInHours > POINTS_LIMIT;

  return (
    // <ResizableBox
    //   className="resizableBox"
    //   width={300}
    //   height={300}
    //   resizeHandles={['e']}
    // >
    // </ResizableBox>
          <div
            style={{
              opacity,
            }}
            className={cn(styles.chartContainer, {
              [styles.cube]: isCube
            })}
            ref={(node) => {
              ref.current = node;
              drag(node);
              drop(node);
            }}
              >
            <div 
              className={styles.chart}
            >
              <div className={styles.combineGroup}>

              <div className={styles.upGroup}>
                <div className={cn(styles.chartHeadingGroup, {
                  [styles.hideDrag]: !handleClickOptions,
                })}
                role="button"
                onMouseDown={() => {
                  allowDragRef.current = true;
                  window.addEventListener('dragend', handleKeyUp);
                }}
                >
                  <div className={styles.chartHeading}><span>{title || 'Chart'}</span></div>
                </div>
  
                {handleClickOptions ? (
                  <div className={styles.controlIcon}>
                    <ActionIcon icon="options" onClick={toggleDropdown} active={dropdownVisible} />
                    {dropdownVisible && (
                      <PopUpMenu
                        position={{ bottom: '-106px', left: '-86px', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
                        items={items}
                        handleChange={setDropdownVisible}
                        handleClickMenu={handleOptionClick} 
                        small
                      />
                    )}
                  </div>
                ) : <div />}
  
              </div>
              <div className={styles.downGroup}>
                 <div className={styles.chartSubheading}>{description?.length ? `${description}` : <div style={{ height: '14px'}} />}</div>
              </div>
              </div>
                <div className={styles.filterBlock}>
                <div>
                    <Select
                      list={[
                        { value: 'pie', title: 'Pie', icon: <div style={{ marginRight: 12, display: 'flex', alignItems: 'center' }}><PieChart /></div> },
                        { value: 'bar', title: 'Bar', icon: <div style={{ marginRight: 12, display: 'flex', alignItems: 'center' }}><BarChart /></div> },
                        { value: 'line', title: 'Line', icon: <div style={{ marginRight: 12, display: 'flex', alignItems: 'center' }}><LineChart /></div> },
                      ]}
                      value={chartType}
                      placeholder="Select chart type"
                      handleChange={(key, value) => {
                        handleUpdateSelect('chartType', value);
                      }}
                      style={{
                        width: 100
                      }}
                    />
                </div>
                <div className={styles.filterButtonGroup}>
                {activeDate ? (
                  <div className={styles.rangeContainer}>
                    <RangePicker
                      inputValue={activeDate}
                      setInputValue={activateDate}
                      runCallback={handleSubmitSend}
                      ranges={ranges}
                      scrollRef={scrollRef}
                      id={id}
                    />
                  </div>

                  ) : null}
                    <Select
                      list={[
                        { value: '1m', title: '1m', disabled: disable1m, activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Time /></div> },
                        { value: '1h', title: '1h', disabled: disable1h, activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Time /></div> },
                        { value: '1d', title: '1d', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Time /></div> },
                        { value: '1M', title: '1M', activeIcon: <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Time /></div> },
                      ]}
                      value={xAxisData?.labelShort}
                      placeholder="Select chart step"
                      handleChange={(key, value) => {
                        handleUpdateSelect('interval', value);
                      }}
                      style={{
                        width: 88
                      }}
                    />

                    <Select
                      list={refreshRates}
                      value={refresh}
                      placeholder="Select refresh"
                      handleChange={(key, value) => {
                        handleUpdateSelect('refresh', value);
                      }}
                      style={{
                        width: 96
                      }}
                    />
                </div>
  
                </div>

              <MemoizedEcharts
                option={customOption}
              />
            </div>
          </div>
  );
}

export default ConnectedChart;
